__turbopack_context__.v({
  "alignable": "index-module-scss-module___npgKW__alignable",
  "body": "index-module-scss-module___npgKW__body",
  "continueButton": "index-module-scss-module___npgKW__continueButton",
  "crossed": "index-module-scss-module___npgKW__crossed",
  "discount": "index-module-scss-module___npgKW__discount",
  "discountedPrice": "index-module-scss-module___npgKW__discountedPrice",
  "isDiscounted": "index-module-scss-module___npgKW__isDiscounted",
  "item": "index-module-scss-module___npgKW__item",
  "line": "index-module-scss-module___npgKW__line",
  "name": "index-module-scss-module___npgKW__name",
  "normalPrice": "index-module-scss-module___npgKW__normalPrice",
  "open": "index-module-scss-module___npgKW__open",
  "simple": "index-module-scss-module___npgKW__simple",
  "summary": "index-module-scss-module___npgKW__summary",
  "summaryBox": "index-module-scss-module___npgKW__summaryBox",
  "summaryHeader": "index-module-scss-module___npgKW__summaryHeader",
  "ticketLine": "index-module-scss-module___npgKW__ticketLine",
  "total": "index-module-scss-module___npgKW__total",
  "value": "index-module-scss-module___npgKW__value",
});
